import type { ReactNode } from 'react';

export const symbol_currency_ruble: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M290-150v-100h-60q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h60v-110h-60q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h60v-330q0-12.75 8.63-21.38Q307.25-840 320-840h230q87.82 0 148.91 61.13t61.09 149Q760-542 698.91-481T550-420H350v110h140q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H350v100q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37Zm60-330h200q63 0 106.5-43.5T700-630q0-63-43.5-106.5T550-780H350v300Z"
		/>
	</svg>
);
